import { IonContent, IonIcon, IonItem, IonLabel, IonList, IonNote, IonPage } from "@ionic/react";
import { arrowBackOutline, buildOutline, chevronForwardOutline, swapHorizontalOutline } from "ionicons/icons";
import { useHistory } from "react-router-dom";

import Header from "src/components/Header";

const OPCIONES = [
  {
    id: "traslados",
    titulo: "Traslados",
    descripcion: "Traslados de equipos, pedidos de activos, retiros de puntos de servicio y fletes",
    icono: swapHorizontalOutline,
    ruta: "/gafcore/solicitudes",
  },
  {
    id: "mantenimientos",
    titulo: "Mantenimientos",
    descripcion: "Pedir que GAF arregle un equipo con una falla (mantenimiento correctivo)",
    icono: buildOutline,
    ruta: "/gafcore/mantenimientos",
  },
];

/**
 * Solicitudes > GafCORE (/gafcore): se elige Traslados o Mantenimientos, igual
 * que el menu Operaciones > Solicitudes a GafCORE de EMSYS. Quien lo ve lo
 * decide solicitudes_gafcore de modulePermissions (todos menos operarios).
 */
const SolicitudesGafcoreMenu: React.FC = () => {
  const history = useHistory();
  return (
    <IonPage>
      <Header titulo="Solicitudes a GafCORE" botonIzq={{ icono: arrowBackOutline, url: "/solicitudes" }} />
      <IonContent id="gafcore-menu">
        <IonNote
          color="medium"
          className="ion-padding-start ion-padding-top"
          style={{ display: "block", fontSize: "0.9rem" }}
        >
          ¿Qué le querés pedir a GAF?
        </IonNote>
        <IonList lines="full">
          {OPCIONES.map((o) => (
            <IonItem key={o.id} button detail={false} onClick={() => history.push(o.ruta)}>
              <IonIcon icon={o.icono} slot="start" color="primary" />
              <IonLabel className="ion-text-wrap">
                <h2 style={{ fontWeight: 600 }}>{o.titulo}</h2>
                <p style={{ fontSize: "0.8rem" }}>{o.descripcion}</p>
              </IonLabel>
              <IonIcon icon={chevronForwardOutline} slot="end" color="medium" />
            </IonItem>
          ))}
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default SolicitudesGafcoreMenu;
